import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, SxProps } from '@mui/material';

interface GenericDialogProps {
  open: boolean;
  title: string;
  cancelButtonText?: string;
  submitButtonText?: string;
  onClose: () => void;
  children: React.ReactNode;
  containerSx?: SxProps;
  titleSx?: SxProps;
}

const GenericDialog: React.FC<GenericDialogProps> =  ({
  open,
  title,
  cancelButtonText = "Cancel",
  onClose,
  children,
  containerSx,
  titleSx,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={titleSx}>{title}</DialogTitle>
      <DialogContent sx={containerSx}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
          {children}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelButtonText}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default GenericDialog;